// The three view chips for Home, My Work and Projects (item #650). Only the
// views the database offers this person are drawn; with one view there is no
// choice, so nothing is drawn.
import type { WorkScope, WorkScopeOption } from './use-work-scope';

export function WorkScopeChips({
  scope,
  options,
  onChange,
  labelFor,
}: {
  scope: WorkScope | null;
  options: WorkScopeOption[];
  onChange: (s: WorkScope) => void;
  /** Projects calls "My facilities" just "Mine" — the cards are mine, not only the buildings. */
  labelFor?: (o: WorkScopeOption) => string;
}) {
  if (options.length < 2) return null;
  return (
    <div className="flex flex-wrap items-center gap-1.5" role="group" aria-label="Which buildings">
      {options.map((o) => {
        const on = o.scope === scope;
        return (
          <button
            key={o.scope}
            type="button"
            aria-pressed={on}
            onClick={() => onChange(o.scope)}
            title={`${o.facilityCount} building${o.facilityCount === 1 ? '' : 's'}`}
            className={[
              'inline-flex min-h-[44px] items-center rounded-full border px-3.5 text-[13px] font-medium transition-colors',
              on
                ? 'border-tcs-inverse bg-tcs-inverse text-tcs-inverse-ink'
                : 'border-tcs-border-strong bg-tcs-bg text-tcs-text-secondary hover:bg-tcs-bg-muted',
            ].join(' ')}
          >
            {labelFor ? labelFor(o) : o.label}
          </button>
        );
      })}
    </div>
  );
}
